import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Orngard from "./applications/Orngard/Orngard.jsx";
import PageNotFound from "./applications/PageNotFound/PageNotFound.js";
import "./root.css";


class App extends Component {
  render() {
    return (
      <div className="app">
        <BrowserRouter basename="/">
          <Switch>
            <Route exact path="/" component={Orngard} />
            <Route path="*" render={() => (<Redirect to="/" />)} />
            <Route component={Orngard} /> 
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
